import { XML_DrawLargeSubchartArrowPPT } from "./XML_DrawLargeSubchartArrowPPT";
import { XML_DrawLargeSubchartArrowPDF } from "./XML_DrawLargeSubchartArrowPDF";
import { enumXMLType } from "../constants";

export function XML_DrawLargeSubchartArrow(
  x0,
  x1,
  x2,
  x3,
  x4,
  y0,
  y1,
  y2,
  fillColor,
  drawElement,
  linkBookmark,
  layer
) {
  var docType = drawElement.GetDocType();

  if (docType == enumXMLType.PDF)
    XML_DrawLargeSubchartArrowPDF(
      x0,
      x1,
      x2,
      x3,
      x4,
      y0,
      y1,
      y2,
      fillColor,
      drawElement,
      linkBookmark,
      layer
    );
  else
    XML_DrawLargeSubchartArrowPPT(
      x0,
      x1,
      x2,
      x3,
      x4,
      y0,
      y1,
      y2,
      fillColor,
      drawElement,
      linkBookmark,
      layer
    );
}
